<template>
  <footer class="app-footer">
    <div class="footer-content">
      <div class="footer-left">
        <span class="copyright-text">
          © {{ new Date().getFullYear() }} Todos os direitos reservados
        </span>
      </div>
      <div class="footer-center">
        <b-link
          href="https://dkp-it.com.br/dkp-sales/"
          target="_blank"
          class="brand-link"
        >
          <span class="brand-text">Sales</span>
          <span class="brand-highlight">Flow</span>
        </b-link>
      </div>
      <div class="footer-right">
        <span class="powered-text">Desenvolvido por</span>
        <b-link
          href="https://dkp-it.com.br/dkp-sales/"
          target="_blank"
          class="company-link"
        >
          DKP IT Solutions
        </b-link>
      </div>
    </div>
  </footer>
</template>

<script>
import { BLink } from 'bootstrap-vue';

export default {
  components: {
    BLink,
  },
};
</script>

<style scoped lang="scss">
.app-footer {
  background: var(--sf-footer-bg);
  padding: 1rem 2rem;
  border-top: 1px solid var(--sf-footer-border);
}

.footer-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1400px;
  margin: 0 auto;
  flex-wrap: wrap;
  gap: 1rem;
}

.footer-left,
.footer-center,
.footer-right {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.copyright-text {
  color: var(--sf-footer-text);
  font-size: 0.85rem;
}

.brand-link {
  display: flex;
  align-items: center;
  text-decoration: none;
  transition: transform 0.3s ease;

  &:hover {
    transform: scale(1.05);
    text-decoration: none;
  }
}

.brand-text {
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--sf-text-primary);
  letter-spacing: 1px;
}

.brand-highlight {
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--sf-footer-highlight);
  letter-spacing: 1px;
}

.powered-text {
  color: var(--sf-footer-text);
  font-size: 0.8rem;
}

.company-link {
  color: var(--sf-footer-link);
  font-size: 0.85rem;
  font-weight: 600;
  text-decoration: none;
  transition: color 0.3s ease;

  &:hover {
    color: var(--sf-footer-link-hover);
    text-decoration: none;
  }
}

@media (max-width: 768px) {
  .footer-content {
    flex-direction: column;
    text-align: center;
  }

  .footer-left,
  .footer-center,
  .footer-right {
    justify-content: center;
  }

  .app-footer {
    padding: 1.5rem 1rem;
  }
}
</style>
